import { PureLightTheme } from '../../../styles/theme'
import { COLORS } from '../../../styles/variables'

export const BoxFooter = {
  width: '100%',
  background: COLORS.SNOW_DRIFT,
}

export const ContainerFooter = {
  display: 'flex',
  alignItems: 'center',
  height: '60px',
  maxWidth: '1112px',
  [PureLightTheme.breakpoints.down('lg')]: {
    padding: '0 30px',
  },
}

export const BoxContent = {
  display: 'flex',
  width: '100%',
  alignItems: 'center',
  justifyContent: 'flex-end',
}

export const fontStyles = {
  color: COLORS.CHARCOAL_GREY,
  fontWeight: 300,
  fontSize: '14px',
  lineHeight: '24px',
}

export const TypFooter = {
  ...fontStyles,
}
